module.exports = __webpack_public_path__ + "img/img-login-portada.a0ee7cca.png";